import { Component, Input, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { DomainViewModel } from '../../../../../services/settings.service';
import { ServerSettingsComponent } from '../server-settings.component';
import { ImageUploadComponent } from "../../../../shared/components/image-upload/image-upload.component";

@Component({
    selector: '[app-domain-settings]',
    templateUrl: './domain-settings.component.html',
    styleUrls: ['./domain-settings.component.css'],
    standalone: false
})
export class DomainSettingsComponent extends ServerSettingsComponent implements OnInit {

  @Input()
  public domain = new DomainViewModel();
  @Input()
  public domains = new Array<DomainViewModel>();

  @ViewChild("innerlogo") innerImage: ImageUploadComponent;
  @ViewChild("outerlogo") outerImage: ImageUploadComponent;
  @ViewChild("favicon") favicon: ImageUploadComponent;

  ngOnInit() {
  }

  public UpdateOuterLogo() {
    this.domain.OuterLogo64 = this.outerImage.files.length ? this.outerImage.files[0].src : null;
  }
  public UpdateInnerLogo() {
    this.domain.InnerLogo64 = this.innerImage.files.length ? this.innerImage.files[0].src : null;
  }
  public UpdateFavicon() {
    this.domain.FavIcon64 = this.favicon.files.length ? this.favicon.files[0].src : null;
  }
}
